<template>
  <v-container>
    <v-card>
      <v-card-title>
        Firmas de correo
        <v-spacer />
        <v-btn class="primary" :disabled="saving" @click="newSignature">Nueva firma</v-btn>
      </v-card-title>
      <v-card-text>
        <v-alert v-if="errorMessage" type="error" dense text>{{ errorMessage }}</v-alert>

        <v-data-table
          :headers="headers"
          :items="signatures"
          :loading="loading"
          no-data-text="No hay firmas cargadas"
          loading-text=""
          :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
        >
          <template v-slot:item.logo="{ item }">
            {{ item.logo ? "Sí" : "—" }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn icon :disabled="saving" @click="editSignature(item)">
              <v-icon color="primary">mode_edit</v-icon>
            </v-btn>
            <v-btn icon :disabled="saving" @click="remove(item)">
              <v-icon color="error">delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog :value="showDialog" max-width="800" persistent @input="cancelEdit">
      <!-- v-if, no solo el :value del dialogo: v-dialog usa el mixin
           bootable, que una vez abierto deja el contenido montado para
           siempre (hasContent = isBooted || eager || isActive). Sin esto el
           formulario sobrevive al cierre con signatureForEdit en null y en la
           segunda apertura no vuelve a correr su mounted() -mismo bug que ya
           paso en la pantalla de empresas-. -->
      <edit-email-signature
        v-if="signatureForEdit"
        :signature="signatureForEdit"
        @cancel="cancelEdit"
        @saved="onSaved"
      />
    </v-dialog>
  </v-container>
</template>

<script>
"use strict";

import emailSignatureService from "@/services/EmailSignatureService";
import editEmailSignature from "@/components/views/emails/edit-email-signature.view.vue";

export default {
  name: "list-email-signatures",
  components: { editEmailSignature },
  data() {
    return {
      signatures: [],
      loading: false,
      // Bandera "en vuelo": sin esto, un borrado que falla deja la fila en la
      // tabla como si hubiera funcionado y no bloquea el resto de los botones.
      saving: false,
      errorMessage: null,
      showDialog: false,
      signatureForEdit: null,
      headers: [
        { text: "Nombre", value: "name" },
        { text: "Logo", value: "logo", sortable: false },
        { text: "Acciones", value: "actions", sortable: false, width: 120 }
      ]
    };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.errorMessage = null;
      this.loading = true;
      try {
        this.signatures = await emailSignatureService.list();
      } catch (error) {
        this.errorMessage = this.messageOf(error, "No se pudieron cargar las firmas");
      } finally {
        this.loading = false;
      }
    },
    // El backend manda el motivo real (nombre repetido, por ejemplo). Se
    // muestra tal cual y solo se cae al texto propio si no vino ninguno.
    messageOf(error, fallback) {
      return (error.response && error.response.data && error.response.data.message) || fallback;
    },
    newSignature() {
      this.signatureForEdit = { name: "", bodyHtml: "", logo: null };
      this.showDialog = true;
    },
    editSignature(item) {
      this.signatureForEdit = JSON.parse(JSON.stringify(item));
      this.showDialog = true;
    },
    cancelEdit() {
      this.showDialog = false;
      this.signatureForEdit = null;
    },
    async onSaved() {
      this.cancelEdit();
      await this.load();
    },
    async remove(item) {
      this.errorMessage = null;
      this.saving = true;
      try {
        await emailSignatureService.remove(item._id);
        await this.load();
      } catch (error) {
        this.errorMessage = this.messageOf(error, "No se pudo borrar la firma");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
